import React, { useEffect, useState, useRef, useCallback } from "react";
import styled, { keyframes } from "styled-components";
import Countdown from "react-countdown"
import { FaLock, FaSearch, FaUnlock } from "react-icons/fa";
import assert from "assert";
import {
  americanFromDecimal,
  americanToDecimal,
  calculateOptimalBets,
  formatSite,
  capitalize,
  round,
  parseGameId,
  getTimeAgo,
  spreadLineDisplay,
  getLiquidityLabel,
  getROIfromDecimalOdds
} from "../Arbitrage/utils"
import BetOptionsModal from "../Arbitrage/modal";
import { API_ENDPOINT_ARBITRAGE, API_KEY, VALID_SITES, SPREAD_MARKETS } from "../Arbitrage/constants";
import { getThemeData } from "../../theme";
import { useGetTheme } from "../../lib/contexts";
//import Socials from "../Socials";
//import { Link } from "rebass";
//import { FaGithub, FaFilePdf } from "react-icons/fa";
import { BodyContainer } from "./tableStyle";
import PageTags from "./pageTags";
import { logoUrl, twitterHandle } from "./constants";
import { getUserScope } from "./protectedAction";
import { ArbitrageProps, ArbitrageContainerProps, TimeDisplayProps, FilterMenuProps, RowContainer2Props, ContentRowProps, ContentItemProps } from "../../lib/interface";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { BlurContainer } from "./tableStyle";
import { Config as config} from "../../lib/config";

const Container = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 100%;
    gap: 42px;
    padding: 22px 0;
    @media screen and (max-width: 555px) {
        flex-direction: column;
        gap: 22px;
    }
`;

const ProfileSectionAlt = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 90%;
`

const ItemList = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: left;
    align-items: center;
    width: 100%;
`

const Divider2 = styled.div`
    height: 12px;
`

const UnlockButton = styled.div`
  display: inline-flex;
  flex-direction: row;
  justify-content: left;
  align-items: center;
  cursor: pointer;
  padding: 12px 6px;
  width: 90%;
  gap: 12px;
  background: ${({color}) => color};
  &:hover {
    filter: brightness(110%);
  }
`

const ContentDisplay = ({ index, data, betSizes, odds1, odds2, odds3, precision, isHeader, showSecret }: ArbitrageProps) => {
  //assert(data['bet_s1']['prop_bet'] == data['bet_s2']['prop_bet'])
  //assert(data['bet_s1']['game_id'] == data['bet_s2']['game_id'])
  //assert(data['bet_s1']['t1_id'] == data['bet_s2']['t1_id'])
  //assert(data['bet_s1']['t2_id'] == data['bet_s2']['t2_id'])
  //assert(data['bet_s1']['league'] == data['bet_s2']['league'])
  const {theme} = useGetTheme();

  const odds1Ref = useRef(odds1);
  const odds2Ref = useRef(odds2);
  const odds3Ref = useRef(odds3);

  const oddsRef1 = useRef<any>(null);
  const oddsRef2 = useRef<any>(null);
  const oddsRef3 = useRef<any>(null);

  const initialValue1 = round(betSizes.site1_bet, precision);
  const initialValue2 = round(betSizes.site2_bet, precision);
  const initialValue3 = round(betSizes.site3_bet, precision);

  const value1Ref = useRef<any>(initialValue1);
  const value2Ref = useRef<any>(initialValue2);
  const value3Ref = useRef<any>(initialValue3);

  const inputRef1 = useRef<any>(null);
  const inputRef2 = useRef<any>(null);
  const inputRef3 = useRef<any>(null);

  const [_, forceRender] = useState(0);

  const fontSize = "0.75rem"

  const c1 = "3.00%";   // roi
  const c2 = "3.00%";   // league
  const c3 = showSecret ? "8.00%": "11.50%";   // event
  const c4 = "6.75%";   // date
  const c5 = "7.25%";   // market
  const c6 = "9.00%";   // position 1
  const c7 = "9.50%";   // site 1
  const c8 = "3.25%";   // odds 1
  const c9 = "9.00%";   // position 2
  const c10 = "9.50%";  // site 2
  const c11 = "3.25%";  // odds 2
  const c12 = "4.25%";  // position 3
  const c13 = "3.75%";  // site 3
  const c14 = "3.25%";  // odds 3
  const c15 = showSecret ? "10.25%" : "13.75%"; // profits and payouts
  const c16 = showSecret ? "3.5%" : "0%";   // sources
  const c17 = showSecret ? "3.5%" : "0%";   // liquidity

  const ContentRow = styled.div`
    display: flex;
    background: ${index % 2 == 0 ? getThemeData(theme).ARBbgBoxAlt1 : getThemeData(theme).ARBbgBox};
    border: 1px solid ${getThemeData(theme).ARBborderBox};
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
    //background: blue;
  `

  const HeaderRow = styled.div`
    display: flex;
    background: ${getThemeData(theme).ARBbgBoxHeader};
    border: 1px solid ${getThemeData(theme).ARBborderBox};
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
    //background: blue;
  `

  const ContentDivider = styled.div`
    border: 1px solid ${getThemeData(theme).ARBborderBox};
  `

  const HeaderDivider = styled.div`
    border: 1px solid ${getThemeData(theme).ARBbgBox};
  `

  const HeaderSpan = styled.span`
    color: ${theme === 'dark' ? getThemeData('light').textColor : getThemeData('dark').textColor};
    font-size: 0.7rem;
    font-weight: 600;
    letter-spacing: 0.025rem;
  `

  const ContentItem = styled.div<ContentItemProps>`
    display: flex;
    flex-direction: column;
    width: ${(props) => props.width || "auto"};
    align-items: left;
    justify-content: center;
    padding: 8px 0px 8px 6px;
    //background: red;
  `

  const ContentSpan = styled.span`
    color: ${getThemeData(theme).ARBtextColor};
    font-size: ${fontSize};
    font-weight: 500;
  `

  const ContentSpanBold = styled.span`
    color: ${getThemeData(theme).ARBtextColor};
    font-size: ${fontSize};
    font-weight: 600;
    letter-spacing: 0.025rem;
  `

  const ContentSiteSpan = styled.span`
    color: ${getThemeData(theme).ARBtextColor};
    font-size: ${fontSize};
    font-weight: 600;
    letter-spacing: 0.025rem;
  `

  const ContentSpanL1 = styled.span`
    color: ${theme === "dark" ? "#FF6B6B" : "#FF4C4C"};
    font-size: ${fontSize};
    font-weight: 600;
    letter-spacing: 0.025rem;
  `

  const ContentSpanL2 = styled.span`
    color: ${theme === "dark" ? "#FF9F6B" : "#FF944C"};
    font-size: ${fontSize};
    font-weight: 600;
    letter-spacing: 0.025rem;
  `

  const ContentSpanL3 = styled.span`
    color: ${theme === "dark" ? "#FFDD6B" : "#FFC107"};
    font-size: ${fontSize};
    font-weight: 600;
    letter-spacing: 0.025rem;
  `

  const ContentSpanL4 = styled.span`
    color: ${theme === "dark" ? "#B4EC7A" : "#7CB342"};
    font-size: ${fontSize};
    font-weight: 600;
    letter-spacing: 0.025rem;
  `

  const ContentSpanL5 = styled.span`
    color: ${theme === "dark" ? "#66BB6A" : "#4CAF50"};
    font-size: ${fontSize};
    font-weight: 600;
    letter-spacing: 0.025rem;
  `

  const ContentSiteSpanUrl = styled.span`
    color: ${getThemeData(theme).ARBtextColorLink};
    font-size: ${fontSize};
    font-weight: 600;
    letter-spacing: 0.025rem;
    cursor: pointer;
  `

  const BetSizeInput = styled.input`
    background: ${getThemeData(theme).ARBbgGlobal};
    color: ${getThemeData(theme).ARBtextColor};
    font-size: ${fontSize};
    width: 80%;
    padding: 2px;
    border-radius: 0px;
    border: 1px solid ${getThemeData(theme).ARBborderBox};
    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
    -moz-appearance: textfield;
  `

  if (isHeader) {
    return (
      <HeaderRow>
        <ContentItem width={c1}>
          <HeaderSpan>
            {`ROI %`}
          </HeaderSpan>
        </ContentItem>
        <HeaderDivider/>
        <ContentItem width={c2}>
          <HeaderSpan>
            {`League`}
          </HeaderSpan>
        </ContentItem>
        <HeaderDivider/>
        <ContentItem width={c3}>
          <HeaderSpan>
            {`Event`}
          </HeaderSpan>
        </ContentItem>
        <HeaderDivider/>
        <ContentItem width={c4}>
          <HeaderSpan>
            {`Date`}
          </HeaderSpan>
        </ContentItem>
        <HeaderDivider/>
        <ContentItem width={c5}>
          <HeaderSpan>
            {`Market`}
          </HeaderSpan>
        </ContentItem>
        <HeaderDivider/>
        <ContentItem width={c6}>
          <HeaderSpan>
            {`Position 1`}
          </HeaderSpan>
        </ContentItem>
        <HeaderDivider/>
        <ContentItem width={c7}>
          <HeaderSpan>
            {`Site 1`}
          </HeaderSpan>
        </ContentItem>
        <HeaderDivider/>
        <ContentItem width={c8}>
          <HeaderSpan>
            {`Odds 1`}
          </HeaderSpan>
        </ContentItem>
        <HeaderDivider/>
        <ContentItem width={c9}>
          <HeaderSpan>
            {`Position 2`}
          </HeaderSpan>
        </ContentItem>
        <HeaderDivider/>
        <ContentItem width={c10}>
          <HeaderSpan>
            {`Site 2`}
          </HeaderSpan>
        </ContentItem>
        <HeaderDivider/>
        <ContentItem width={c11}>
          <HeaderSpan>
            {`Odds 2`}
          </HeaderSpan>
        </ContentItem>
        {/*<HeaderDivider/>
        <ContentItem width={c12}>
          <HeaderSpan>
            {`Position 3`}
          </HeaderSpan>
        </ContentItem>
        <HeaderDivider/>
        <ContentItem width={c13}>
          <HeaderSpan>
            {`Site 3`}
          </HeaderSpan>
        </ContentItem>
        <HeaderDivider/>
        <ContentItem width={c14}>
          <HeaderSpan>
            {`Odds 3`}
          </HeaderSpan>
        </ContentItem>*/}
        <HeaderDivider/>
        <ContentItem width={c15}>
          <HeaderSpan>
            {`Profits & Payouts`}
          </HeaderSpan>
        </ContentItem>
        {showSecret &&
        <>
        <HeaderDivider/>
        <ContentItem width={c16}>
          <HeaderSpan>
            {`Source(s)`}
          </HeaderSpan>
        </ContentItem>
        <HeaderDivider/>
        <ContentItem width={c17}>
          <HeaderSpan>
            {`Liquidity`}
          </HeaderSpan>
        </ContentItem>
        </>}
      </HeaderRow>
    );
  } else {

    const league = data['bet_s1']['league'];
    const gameInfo = parseGameId(
      data['bet_s1']['game_id'],
      data['bet_s1']['t1_id'],
      data['bet_s1']['t2_id'],
      'game_time' in data['bet_s1'] ? data['bet_s1']['game_time'] : null,
      'game_time' in data['bet_s2'] ? data['bet_s2']['game_time'] : null,
    );

    const adjustBetSizesOddsChange = () => {
      const newBets = calculateOptimalBets(
        americanToDecimal(odds1Ref.current),
        americanToDecimal(odds2Ref.current),
        value1Ref.current,
        precision,
        odds3Ref.current !== null ? americanToDecimal(odds3Ref.current) : null,
      );
      value1Ref.current = newBets.site1_bet;
      value2Ref.current = newBets.site2_bet;
    }

    const handleOddsChange = (e:any, t:any) => {
      const inputValue = e.target.value;
      if (inputValue !== undefined && inputValue !== null) {
        if (t == 1) {
          odds1Ref.current = inputValue;
          adjustBetSizesOddsChange();
          forceRender((prev) => prev + 1);
          setTimeout(() => {
            oddsRef1.current.focus();
          }, 10);
        } else if (t == 2) {
          odds2Ref.current = inputValue;
          adjustBetSizesOddsChange();
          forceRender((prev) => prev + 1);
          setTimeout(() => {
            oddsRef2.current.focus();
          }, 10);
        } else if (t == 3) {
          odds3Ref.current = inputValue;
          adjustBetSizesOddsChange();
          forceRender((prev) => prev + 1);
          setTimeout(() => {
            oddsRef3.current.focus();
          }, 10);
        }
      }
    }

    const handleValueChange = (e:any, t:any) => {
      const inputValue = e.target.value;
      if (inputValue !== undefined && inputValue !== null) {
        if (t == 1) {
          const newValue1 = round(parseFloat(inputValue), precision);
          const newBets = calculateOptimalBets(
            americanToDecimal(odds1Ref.current),
            americanToDecimal(odds2Ref.current),
            newValue1,
            precision,
            odds3Ref.current !== null ? americanToDecimal(odds3Ref.current) : null,
          );
          const newValue2 = newBets.site2_bet;
          const newValue3 = newBets.site3_bet;
          value1Ref.current = newValue1;
          value2Ref.current = newValue2;
          value3Ref.current = newValue3;
          forceRender((prev) => prev + 1);
          setTimeout(() => {
            inputRef1.current.focus();
          }, 10);
        } else if (t == 2) {
          const newValue2 = round(parseFloat(inputValue), precision);
          const newBets = calculateOptimalBets(
            americanToDecimal(odds2Ref.current),
            americanToDecimal(odds1Ref.current),
            newValue2,
            precision,
            odds3Ref.current !== null ? americanToDecimal(odds3Ref.current) : null,
          );
          const newValue1 = newBets.site2_bet;
          const newValue3 = newBets.site3_bet;
          value1Ref.current = newValue1;
          value2Ref.current = newValue2;
          value3Ref.current = newValue3;
          forceRender((prev) => prev + 1);
          setTimeout(() => {
            inputRef2.current.focus();
          }, 10);
        } else if (t == 3) {
          const newValue3 = round(parseFloat(inputValue), precision);
          const newBets = calculateOptimalBets(
            americanToDecimal(odds3Ref.current),
            americanToDecimal(odds1Ref.current),
            newValue3,
            precision,
            americanToDecimal(odds2Ref.current),
          );
          const newValue1 = newBets.site2_bet;
          const newValue2 = newBets.site3_bet;
          value1Ref.current = newValue1;
          value2Ref.current = newValue2;
          value3Ref.current = newValue3;
          forceRender((prev) => prev + 1);
          setTimeout(() => {
            inputRef3.current.focus();
          }, 10);
        }
      }
    };

    const calculateMinMaxProfit = (width:any) => {
      let value1 = value1Ref.current;
      let value2 = value2Ref.current;
      let value3 = value3Ref.current;
      let site1_payout = parseFloat(value1) * americanToDecimal(odds1Ref.current);
      let site2_payout = parseFloat(value2) * americanToDecimal(odds2Ref.current);
      let site3_payout = (value3 !== null && odds3Ref.current !== null)
                         ? parseFloat(value3) * americanToDecimal(odds3Ref.current)
                         : null;
      let profit1;
      let profit2;
      let profit3;
      let min_profit: number;
      let max_profit: number;
      if (site3_payout !== null) {
        profit1 = site1_payout - parseFloat(value1) - parseFloat(value2) - parseFloat(value3);
        profit2 = site2_payout - parseFloat(value1) - parseFloat(value2) - parseFloat(value3);
        profit3 = site3_payout - parseFloat(value1) - parseFloat(value2) - parseFloat(value3);
        min_profit = Math.min(profit1, profit2, profit3)
        max_profit = Math.max(profit1, profit2, profit3)
      } else {
        profit1 = site1_payout - parseFloat(value1) - parseFloat(value2);
        profit2 = site2_payout - parseFloat(value1) - parseFloat(value2);
        min_profit = Math.min(profit1, profit2)
        max_profit = Math.max(profit1, profit2)
      }
      return (
        <ContentItem width={width}>
          <ContentSpan>
            {`Profits: `}
            {min_profit >= 0 ? "+$" : "-$"}
            {Math.abs(min_profit).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
            {` / `}
            {max_profit >= 0 ? "+$" : "-$"}
            {Math.abs(max_profit).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
          </ContentSpan>
          <div style={{display: "block", height: "4px"}}/>
          <ContentSpan>
            {`Payouts: $${site1_payout.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`}
            {` / `}
            {`$${site2_payout.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`}
          </ContentSpan>
        </ContentItem>
      );
    }

    return (
      <ContentRow>
        <ContentItem width={c1}>
          <ContentSpanBold>
            {getROIfromDecimalOdds(
              americanToDecimal(odds1Ref.current),
              americanToDecimal(odds2Ref.current),
              odds3Ref.current !== null ? americanToDecimal(odds3Ref.current) : null,
              true
            )}
          </ContentSpanBold>
        </ContentItem>
        <ContentDivider/>
        <ContentItem width={c2}>
          <ContentSpan>
            {gameInfo.league}
          </ContentSpan>
        </ContentItem>
        <ContentDivider/>
        <ContentItem width={c3}>
          <ContentSpan>
            {gameInfo.matchup}
          </ContentSpan>
        </ContentItem>
        <ContentDivider/>
        <ContentItem width={c4}>
          <ContentSpan>
            {gameInfo.formattedTime}
          </ContentSpan>
        </ContentItem>
        <ContentDivider/>
        <ContentItem width={c5}>
          <ContentSpan>
            {data['bet_s1']['prop_bet']
              .replaceAll(`-`,` `)
              .replace(' over','')
              .replace(' under','')
              .toLowerCase()
              .split(' ')
              .map((word: any) => { return word.charAt(0).toUpperCase() + word.slice(1)})
              .join(' ')
            }
          </ContentSpan>
        </ContentItem>
        <ContentDivider/>
        <ContentItem width={c6}>
          <ContentSpan>
            {data['bet_s1']['prop_side'] && `${
              data['bet_s1']['prop_side']
                .replace(`${league}-`,'')
                .replaceAll(`-`,` `)
                .toLowerCase()
                .split(' ')
                .map((word: any) => { return word.charAt(0).toUpperCase() + word.slice(1)})
                .join(' ')
            }`}
            {` `}
            {data['bet_s1']['prop_bet'] !== 'moneyline' &&
             (data['bet_s1']['prop_bet'].includes('-over')
              ? `Over ${data['bet_s1']['prop_line']}`
              : (data['bet_s1']['prop_bet'].includes('-under')
                ? `Under ${data['bet_s1']['prop_line']}`
                : (SPREAD_MARKETS.includes(data['bet_s1']['prop_bet'])
                  ? `${spreadLineDisplay(data['bet_s1']['prop_line'])}`
                  : null
                  )
                )
             )
            }
          </ContentSpan>
        </ContentItem>
        <ContentDivider/>
        <ContentItem width={c7}>
          <div style={{display: "flex", flexDirection: "row", justifyContent: "left", alignItems: "center", gap: "4px"}}>
            {data['market_url_s1'] !== undefined && data['market_url_s1'] !== null
            ? <a href={data['market_url_s1']} target="_blank" style={{textDecoration: "none"}}>
                <ContentSiteSpanUrl>
                {formatSite(data['bet_s1']['site_id'])}
              </ContentSiteSpanUrl>
            </a>
            :  <ContentSiteSpan>
              {formatSite(data['bet_s1']['site_id'])}
            </ContentSiteSpan>
            }
            {data['bet_s1']['prop_liquidity'] !== undefined && data['bet_s1']['prop_liquidity'] !== null &&
              <ContentSpan>
                {`($${data['bet_s1']['prop_liquidity'].toLocaleString()})`}
              </ContentSpan>
            }
          </div>
          <div style={{display: "block", height: "4px"}}/>
          <div style={{display: "flex", flexDirection: "row", justifyContent: "left", alignItems: "center", gap: "4px"}}>
            <ContentSpan>
              {"$"}
            </ContentSpan>
            <BetSizeInput
              type="number"
              ref={inputRef1}
              value={value1Ref.current}
              onChange={(e) => handleValueChange(e, 1)}
              step={"0.01"}
            />
          </div>
        </ContentItem>
        <ContentDivider/>
        <ContentItem width={c8}>
          <ContentSpan>
            <BetSizeInput
              type="text"
              ref={oddsRef1}
              value={odds1Ref.current}
              onChange={(e) => handleOddsChange(e, 1)}
            />
          </ContentSpan>
        </ContentItem>
        <ContentDivider/>
        <ContentItem width={c9}>
          <ContentSpan>
            {data['bet_s2']['prop_side'] && `${
              data['bet_s2']['prop_side']
                .replace(`${league}-`,'')
                .replaceAll(`-`,` `)
                .toLowerCase()
                .split(' ')
                .map((word: any) => { return word.charAt(0).toUpperCase() + word.slice(1)})
                .join(' ')
            }`}
            {` `}
            {data['bet_s2']['prop_bet'] !== 'moneyline' &&
             (data['bet_s2']['prop_bet'].includes('-over')
              ? `Over ${data['bet_s2']['prop_line']}`
              : (data['bet_s2']['prop_bet'].includes('-under')
                ? `Under ${data['bet_s2']['prop_line']}`
                : (SPREAD_MARKETS.includes(data['bet_s2']['prop_bet'])
                  ? `${spreadLineDisplay(data['bet_s2']['prop_line'])}`
                  : null
                  )
                )
             )
            }
          </ContentSpan>
        </ContentItem>
        <ContentDivider/>
        <ContentItem width={c10}>
          <div style={{display: "flex", flexDirection: "row", justifyContent: "left", alignItems: "center", gap: "4px"}}>
            {data['market_url_s2'] !== undefined && data['market_url_s2'] !== null
            ? <a href={data['market_url_s2']} target="_blank" style={{textDecoration: "none"}}>
                <ContentSiteSpanUrl>
                {formatSite(data['bet_s2']['site_id'])}
              </ContentSiteSpanUrl>
            </a>
            :  <ContentSiteSpan>
              {formatSite(data['bet_s2']['site_id'])}
            </ContentSiteSpan>
            }
            {data['bet_s2']['prop_liquidity'] !== undefined && data['bet_s2']['prop_liquidity'] !== null &&
              <ContentSpan>
                {`($${data['bet_s2']['prop_liquidity'].toLocaleString()})`}
              </ContentSpan>
            }
          </div>
          <div style={{display: "block", height: "4px"}}/>
          <div style={{display: "flex", flexDirection: "row", justifyContent: "left", alignItems: "center", gap: "4px"}}>
            <ContentSpan>
              {"$"}
            </ContentSpan>
            <BetSizeInput
              type="number"
              ref={inputRef2}
              value={value2Ref.current}
              onChange={(e) => handleValueChange(e, 2)}
              step={"0.01"}
            />
          </div>
        </ContentItem>
        <ContentDivider/>
        <ContentItem width={c11}>
          <ContentSpan>
            <BetSizeInput
              type="text"
              ref={oddsRef2}
              value={odds2Ref.current}
              onChange={(e) => handleOddsChange(e, 2)}
            />
          </ContentSpan>
        </ContentItem>
        {/*
        <ContentDivider/>
        <ContentItem width={c12}>
          <ContentSpan>
            {'bet_s3' in data && data['bet_s3'] !== undefined && data['bet_s3']['prop_side'] && `${
              data['bet_s3']['prop_side']
                .replace(`${league}-`,'')
                .replaceAll(`-`,` `)
                .toLowerCase()
                .split(' ')
                .map((word: any) => { return word.charAt(0).toUpperCase() + word.slice(1)})
                .join(' ')
            }`}
            {'bet_s3' in data && data['bet_s3'] !== undefined && ` `}
            {'bet_s3' in data && data['bet_s3'] !== undefined && data['bet_s3']['prop_bet'] !== 'moneyline' &&
             (data['bet_s3']['prop_bet'].includes('-over')
              ? `Over ${data['bet_s3']['prop_line']}`
              : (data['bet_s3']['prop_bet'].includes('-under')
                ? `Under ${data['bet_s3']['prop_line']}`
                : (SPREAD_MARKETS.includes(data['bet_s3']['prop_bet'])
                  ? `${spreadLineDisplay(data['bet_s3']['prop_line'])}`
                  : null
                  )
                )
             )
            }
          </ContentSpan>
        </ContentItem>
        <ContentDivider/>
        <ContentItem width={c13}>
          {'bet_s3' in data &&
            <>
              <div style={{display: "flex", flexDirection: "row", justifyContent: "left", alignItems: "center", gap: "4px"}}>
                {data['market_url_s3'] !== undefined && data['market_url_s3'] !== null
                ? <a href={data['market_url_s3']} target="_blank" style={{textDecoration: "none"}}>
                    <ContentSiteSpanUrl>
                    {formatSite(data['bet_s3']['site_id'])}
                  </ContentSiteSpanUrl>
                </a>
                :  <ContentSiteSpan>
                  {formatSite(data['bet_s3']['site_id'])}
                </ContentSiteSpan>
                }
                {data['bet_s3']['prop_liquidity'] !== undefined && data['bet_s3']['prop_liquidity'] !== null &&
                  <ContentSpan>
                    {`($${data['bet_s3']['prop_liquidity'].toLocaleString()})`}
                  </ContentSpan>
                }
              </div>
              <div style={{display: "block", height: "4px"}}/>
              <div style={{display: "flex", flexDirection: "row", justifyContent: "left", alignItems: "center", gap: "4px"}}>
                <ContentSpan>
                  {"$"}
                </ContentSpan>
                <BetSizeInput
                  type="number"
                  ref={inputRef3}
                  value={value3Ref.current}
                  onChange={(e) => handleValueChange(e, 3)}
                  step={"0.01"}
                />
              </div>
            </>
          }
        </ContentItem>
        <ContentDivider/>
        <ContentItem width={c14}>
          <ContentSpan>
            <BetSizeInput
              type="text"
              ref={oddsRef3}
              value={odds3Ref.current}
              onChange={(e) => handleOddsChange(e, 3)}
            />
          </ContentSpan>
        </ContentItem>
        */}
        <ContentDivider/>
        {calculateMinMaxProfit(c15)}
        {showSecret &&
        <>
        <ContentDivider/>
        <ContentItem width={c16}>
          <ContentSpan>
            {data['sources'].join(", ").toUpperCase()}
          </ContentSpan>
        </ContentItem>
        <ContentDivider/>
        <ContentItem width={c17}>
          {data['liquidity_rating'] == 0 && <ContentSpanL1>{`${getLiquidityLabel(data['liquidity_rating'])} (${data['liquidity_rating']})`}</ContentSpanL1>}
          {data['liquidity_rating'] == 1 && <ContentSpanL2>{`${getLiquidityLabel(data['liquidity_rating'])} (${data['liquidity_rating']})`}</ContentSpanL2>}
          {data['liquidity_rating'] == 2 && <ContentSpanL3>{`${getLiquidityLabel(data['liquidity_rating'])} (${data['liquidity_rating']})`}</ContentSpanL3>}
          {data['liquidity_rating'] == 3 && <ContentSpanL4>{`${getLiquidityLabel(data['liquidity_rating'])} (${data['liquidity_rating']})`}</ContentSpanL4>}
          {data['liquidity_rating'] == 4 && <ContentSpanL5>{`${getLiquidityLabel(data['liquidity_rating'])} (${data['liquidity_rating']})`}</ContentSpanL5>}
        </ContentItem>
        </>}
      </ContentRow>
    );
  }
}

const TimeDisplay = ({ timestamp, }: TimeDisplayProps) => {
  /*const timeAgo = getTimeAgo(timestamp);*/
  const dateTime = (new Date(timestamp)).toLocaleString();
  const {theme} = useGetTheme();

  return (
    <>
      <span style={{ color: getThemeData(theme).ARBtextColor, fontWeight: 600, fontSize: "1rem" }}>
        {`${dateTime} `}
      </span>
      {/*<span style={{ color: getThemeData(theme).ARBtextColor, fontWeight: 400, fontSize: "0.85rem", paddingLeft: "4px" }}>
        {`(over ${timeAgo})`}
      </span>*/}
    </>
  );
};

const FilterMenu = ({ filters, selectedFilters, setSelectedFilters, precision, setPrecision }: FilterMenuProps) => {
  const precisionOptions = [0,1,2];
  const {theme} = useGetTheme();
  const [selectAll, setSelectAll] = useState(selectedFilters.size == filters.size);

  useEffect(() => {
    if (selectedFilters.size === filters.size) {
      setSelectAll(true);
    } else {
      setSelectAll(false);
    }
  }, [selectedFilters, filters]);

  const toggleFilter = (siteId: any) => {
    const updatedFilters = new Set(selectedFilters);
    if (updatedFilters.has(siteId)) {
      updatedFilters.delete(siteId);
    } else {
      updatedFilters.add(siteId);
    }
    setSelectedFilters(updatedFilters);
  };

  const toggleSelectAll = () => {
    if (selectAll) {
      setSelectedFilters(new Set());
    } else {
      setSelectedFilters(new Set(filters));
    }
    setSelectAll(!selectAll);
  };

  const handlePrecisionChange = (e: any) => {
    const inputValue = e;
    if ((inputValue !== undefined) &&
        (inputValue !== null) &&
        (inputValue == 0 || inputValue == 1 || inputValue == 2)
    ) {
      setPrecision(parseInt(inputValue));
    }
  }

  const SectionDivider = styled.div`
    display: block;
    height: 12px;
  `

  const PrecisionInput = styled.input`
    background: ${getThemeData(theme).ARBbgGlobal};
    color: ${getThemeData(theme).ARBtextColor};
    font-size: 0.85rem;
    width: 80%;
    padding: 2px;
    border-radius: 0px;
    border: 1px solid ${getThemeData(theme).ARBborderBox};
    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
    -moz-appearance: textfield;
  `

  return (
    <div style={{display: "flex", flexDirection: "column", gap: "2px", justifyContent: "left", alignItems: "center"}}>
      <div style={{display: "flex", flexDirection: "row", width: "100%"}}>
        <span style={{color: getThemeData(theme).ARBtextColor, fontWeight: 600}}>
          Precision
        </span>
      </div>
      <SectionDivider/>
      <div style={{display: "flex", flexDirection: "row", width: "100%"}}>
        {precisionOptions.map((value) => {
          return (
            <div style={{display: "flex", flexDirection: "row"}}>
              <label key={`prec${value}`} style={{
                display: "block",
                margin: "5px 0",
                color: getThemeData(theme).ARBtextColor
              }}>
                <PrecisionInput
                  type="checkbox"
                  checked={precision === value}
                  onChange={() => handlePrecisionChange(value)}
                  style={{cursor: "pointer"}}
                />
                {value}
              </label>
            </div>
          );
        })}
      </div>
      <SectionDivider/>
      <div style={{display: "block", width: "100%", height: "1px", background: getThemeData(theme).ARBborderBox}}/>
      <SectionDivider/>
      <div style={{display: "flex", flexDirection: "row", width: "100%"}}>
        <span style={{color: getThemeData(theme).ARBtextColor, fontWeight: 600}}>
          Sites
        </span>
      </div>
      <SectionDivider/>
      <div style={{display: "flex", flexDirection: "row", width: "100%"}}>
        <label style={{
          display: "block",
          margin: "5px 0",
          color: getThemeData(theme).ARBtextColor
        }}>
          <input
            type="checkbox"
            checked={selectAll}
            onChange={toggleSelectAll}
            style={{cursor: "pointer"}}
          />
          Select All
        </label>
      </div>
      {Array.from(filters).map((siteId:any) => (
        <div style={{display: "flex", flexDirection: "row", width: "100%"}}>
          <label key={siteId} style={{
            display: "block",
            margin: "5px 0",
            color: getThemeData(theme).ARBtextColor
          }}>
            <input
              type="checkbox"
              checked={selectedFilters.has(siteId)}
              onChange={() => toggleFilter(siteId)}
              style={{cursor: "pointer"}}
            />
            {formatSite(siteId)}
          </label>
        </div>
      ))}
    </div>
  );
};

const Arbitrage = ({
  isMobile,
  showSubMenu,
  showSecret,
  restrictRowsAfterN,
  setSnackBarType,
  setSnackBarTitle,
}: ArbitrageContainerProps) => {
  const intervalSec = 60;
  const minBetSize = 100;
  const defaultFilters = new Set(VALID_SITES);
  const {theme} = useGetTheme();
  const [precision, setPrecision] = useState(() => {
    const storedPrecision = localStorage.getItem("precision");
    return storedPrecision ? parseInt(JSON.parse(storedPrecision)) : 0;
  });
  const [section, setSection] = useState(1);
  const [responseData, setResponseData] = useState(() => {
    const storedResponseData = localStorage.getItem("data");
    return storedResponseData ? new Set(JSON.parse(storedResponseData)) : {'data': [], 'updated_at': 0};
  });
  const [data, setData] = useState({'data': [], 'updated_at': 0});
  const [betSizes, setBetSizes] = useState<any>([]);
  const [allFilters, _] = useState(defaultFilters);
  const [selectedFilters, setSelectedFilters] = useState(() => {
    const storedFilters = localStorage.getItem("filters");
    return storedFilters ? new Set(JSON.parse(storedFilters)) : defaultFilters;
  });
  const [odds1, setOdds1] = useState<any>([]);
  const [odds2, setOdds2] = useState<any>([]);
  const [odds3, setOdds3] = useState<any>([]);

  const navigate = useNavigate();
  const userScope = getUserScope();
  const canViewAdv = (userScope !== 0 && userScope !== 1);

  const fontSize = "0.85rem"
  const c1 = "3.00%";   // roi

  const ContentRowNone = styled.div<ContentRowProps>`
    display: flex;
    background: ${(props) => props.ix % 2 == 0 ? getThemeData(theme).ARBbgBoxAlt1 : getThemeData(theme).ARBbgBox};
    border: 1px solid ${getThemeData(theme).ARBborderBox};
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
    //background: blue;
  `

  const ContentDivider = styled.div`
    border: 1px solid ${getThemeData(theme).ARBborderBox};
  `
  const ContentSpan = styled.span`
    color: ${getThemeData(theme).ARBtextColor};
    font-size: ${fontSize};
    font-weight: 500;
  `

  const ContentSpanBold = styled.span`
    color: ${getThemeData(theme).ARBtextColor};
    font-size: ${fontSize};
    font-weight: 600;
    letter-spacing: 0.025rem;
  `

  const ContentItem = styled.div<ContentItemProps>`
    display: flex;
    flex-direction: column;
    width: ${(props) => props.width || "auto"};
    align-items: left;
    justify-content: center;
    padding: 8px 0px 8px 6px;
    //background: red;
  `

  //const [showLock, setShowLock] = useState<boolean[]>([true, ...Array(betRows.length).fill(false)]);

  async function getData() {
    try {
      const response = await fetch(API_ENDPOINT_ARBITRAGE, {
        method: 'GET',
        headers: {
          "Accept": "application/json",
          "Authorization": API_KEY,
        },
      });
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      let res_data = await response.json();
      setResponseData(res_data)
      res_data['data'] = [...res_data['data']].sort(function(a, b) {
        return b.profit_percentage - a.profit_percentage;
      }).filter((item) => {
        return selectedFilters.has(item['bet_s1']['site_id']) && selectedFilters.has(item['bet_s2']['site_id'])
      });
      console.log('Fetched data', res_data)
      setData(res_data);
    } catch (error) {
      console.error('There was an error fetching the data:', error);
    }
  }

  useEffect(() => {
    getData();

    const intervalId = setInterval(() => {
      getData();
    }, intervalSec*1000);

    return () => {
      clearInterval(intervalId);
    };
  },[]);

  useEffect(() => {
    localStorage.setItem("filters", JSON.stringify([...selectedFilters]));
    let res_data: any = { ...responseData };
    res_data['data'] = [...res_data['data']].sort(function(a:any, b:any) {
      return b.profit_percentage - a.profit_percentage;
    }).filter((item) => {
      return selectedFilters.has(item['bet_s1']['site_id']) && selectedFilters.has(item['bet_s2']['site_id'])
    });
    setData(res_data);
  }, [selectedFilters]);

  useEffect(() => {
    localStorage.setItem("precision", JSON.stringify(precision));
    setBetSizes([]);
    setOdds1([]);
    setOdds2([]);
    setOdds3([]);
    setData({ ...data });
  },[precision]);

  useEffect(() => {
    setBetSizes([...data['data']].map((item: any) => {
      return calculateOptimalBets(
        item['bet_s1']['prop_odds'],
        item['bet_s2']['prop_odds'],
        minBetSize,
        precision,
        'bet_s3' in item ? item['bet_s3']['prop_odds'] : null,
      )})
    );
    setOdds1([...data['data']].map((item: any) => { return americanFromDecimal(item['bet_s1']['prop_odds'], true)}));
    setOdds2([...data['data']].map((item: any) => { return americanFromDecimal(item['bet_s2']['prop_odds'], true)}));
    setOdds3([...data['data']].map(item => {
      return ('bet_s3' in item ? americanFromDecimal(item['bet_s3']['prop_odds'], true) : null)
    }));
  }, [data]);

  const CountdownWrapper = () => <Countdown date={Date.now() + (intervalSec * 1000)} renderer={props => <>{props.seconds+1}</>}/>;
  const MemoCountdown = React.memo(CountdownWrapper);

  return (
    <BodyContainer width={
      isMobile
      ? '90%'
      : (showSubMenu
        ? 'calc(100% - 12px)'//`calc(100% - ${lgSubMenuW})`
        : 'calc(100% - 12px)'//`calc(100% - ${smSubMenuW})`
      )}>
      <PageTags
        pageUrl={`${window.location.href}`}
        pageTitle={"🔥 Arbitrage"}
        pageDescription={"Capitalize on odds differences across bookies and markets to guarantee risk-free profit."}
        pageImageUrl={logoUrl}
        pageTwitter={twitterHandle}
      />
      <Container>
        <ProfileSectionAlt>
          <div style={{ display: "flex", flexDirection: "row", paddingTop: "42px", width: "100%", justifyContent: "left"}}>
            <span style={{
              color: section === 1
                ? getThemeData(theme).ARBtextColor
                : getThemeData(theme).ARBtextColor,
              fontWeight: 600,
              fontSize: "1.6rem",
              cursor: "pointer"
            }} onClick={() => {
              setSection(1)
            }}>
              {"🔥 Arbitrage"}
            </span>
          </div>
        </ProfileSectionAlt>
      </Container>
      <Container>
        <ProfileSectionAlt>
          <Divider2 />
          {section === 1
            &&
            <>
              <div style={{ display: "flex", flexDirection: "row", paddingBottom: "22px", width: "100%", justifyContent: "left" }}>
                {data['updated_at'] != 0 && (<>
                  <span style={{ color: getThemeData(theme).ARBtextColor, fontWeight: 400, fontSize: "1rem", paddingRight: "4px"}}>
                    {"Last Update:"}
                  </span>
                  <TimeDisplay timestamp={data['updated_at']}/>
                </>)}
              </div>
              <div style={{ display: "flex", flexDirection: "row", paddingBottom: "22px", width: "100%", justifyContent: "left"}}>
                <span style={{ color: getThemeData(theme).ARBtextColor, fontSize: "1rem" }}>
                  {`Requesting data in `}
                  <MemoCountdown/>
                  {` seconds...`}
                </span>
              </div>
              <div style={{ display: "flex", flexDirection: "row", paddingBottom: "22px", width: "100%", justifyContent: "left"}}>
                <BetOptionsModal
                  buttonTitle={"Settings"}
                  modalTitle={"Settings"}
                  modalContent={
                    <FilterMenu
                      filters={allFilters}
                      selectedFilters={selectedFilters}
                      setSelectedFilters={setSelectedFilters}
                      precision={precision}
                      setPrecision={setPrecision}
                    />
                  }
                />
              </div>
              <ItemList>
                {data['data'].length == 0 && <div style={{ display: "flex", flexDirection: "row", paddingBottom: "22px", width: "100%", justifyContent: "left"}}>
                  <span style={{ color: getThemeData(theme).ARBtextColor, fontSize: "1rem" }}>
                    {`No Results`}
                  </span>
                </div>}
                {data['data'].length > 0 &&
                 betSizes.length != data['data'].length &&  <div style={{ display: "flex", flexDirection: "row", paddingBottom: "22px", width: "100%", justifyContent: "left"}}>
                  <span style={{ color: getThemeData(theme).ARBtextColor, fontSize: "1rem" }}>
                    {`Loading...`}
                  </span>
                </div>}
                {data['data'].length > 0 &&
                 betSizes.length == data['data'].length &&
                  <ContentDisplay
                    index={null}
                    data={null}
                    betSizes={{site1_bet: 0, site2_bet: 0}}
                    odds1={null}
                    odds2={null}
                    odds3={null}
                    precision={precision}
                    isHeader={true}
                    showSecret={showSecret}
                  />
                }
                {data['data'].length > 0 &&
                 betSizes.length == data['data'].length &&
                 data['data'].map((item:any, index) => {
                  if ((userScope === 0 || userScope === 1) && ((index+1) > restrictRowsAfterN)) {
                    const gameInfo = parseGameId(item['bet_s1']['game_id'], item['bet_s1']['t1_id'], item['bet_s1']['t2_id']);
                    return (
                      <ContentRowNone ix={index}>
                         <ContentItem width={c1}>
                          <ContentSpanBold>
                            {getROIfromDecimalOdds(
                              item['bet_s1']['prop_odds'],
                              item['bet_s2']['prop_odds'],
                              'bet_s3' in item ? item['bet_s3']['prop_odds'] : null,
                              true
                            )}
                          </ContentSpanBold>
                        </ContentItem>
                        <div style={{display: "inline-flex", flexDirection: "row", justifyContent: "left", width: `97%`, alignItems: "center"}}>
                          <UnlockButton color={
                            //`linear-gradient(to right, ${getThemeData(theme).bgBlurGlobal}, rgba(188, 189, 190, 0))`
                            'transparent'
                          }
                            //onMouseEnter={() => {
                            //  let cnew = [...showLock];
                            //  cnew[index] = false;
                            //  setShowLock([...cnew]);
                            //}}
                            //onMouseLeave={() => {
                            //  let cnew = [...showLock];
                            //  cnew[index] = true;
                            //  setShowLock([...cnew]);
                            //}}
                            onClick={() => {
                              if (userScope === 0) {
                                navigate("/account");
                                setTimeout(() => {
                                  navigate("/account?login=true");
                                },200);
                              } else {
                                setSnackBarTitle("Upgrade your subscription")
                                setSnackBarType("customWarning")
                                setTimeout(() => {
                                  setSnackBarType(undefined);
                                  setSnackBarTitle(undefined);
                                }, config.snackTimeout);
                              }
                            }}>
                            <div style={{width: "4px"}}/>
                            <FaLock color={getThemeData(theme).textColor} size={"14px"} />
                            {/*showLock[index] && <FaLock color={getThemeData(theme).textColor} size={"14px"} />*/}
                            {/*!showLock[index] && <FaUnlock color={getThemeData(theme).textColor} size={"14px"} />*/}
                            <ContentSpan>
                              {`Unlock`}
                            </ContentSpan>
                          </UnlockButton>
                        </div>
                      </ContentRowNone>
                    );
                  } else {
                    return (
                        <ContentDisplay
                          index={index}
                          data={item}
                          betSizes={betSizes[index]}
                          odds1={odds1[index]}
                          odds2={odds2[index]}
                          odds3={odds3[index]}
                          precision={precision}
                          isHeader={false}
                          showSecret={showSecret}
                        />
                    );
                  }
                })}
              </ItemList>
            </>
          }
        </ProfileSectionAlt>
      </Container>
    </BodyContainer>
  );
};

export default Arbitrage;